export const STATUS_PENDING = 'pending';
export const STATUS_AUTHORIZED = 'authorized';
export const STATUS_CAPTURED = 'captured';
export const STATUS_FAILED = 'failed';
export const STATUS_REFUNDED = 'refunded';
export const STATUS_CANCELLED = 'cancelled';
export const STATUS_PAID = 'paid';
export const PAYMENT_METHOD_CB = 'CB';
export const PAYMENT_METHOD_TFE = 'TFE';
export const PROVIDER_STRIPE = 'stripe';
export const PROVIDER_PANDAPAY = 'pandapay';
export const PROVIDER_PAYPAL = 'paypal';
export const PROVIDER_NUVEI = 'nuvei';
export const CURRENCY_EUR = 'EUR';
export const CURRENCY_USD = 'USD';
export const CURRENCY_CAD = 'CAD';

export const TRANSACTION_STATUSES = [
  STATUS_PENDING,
  STATUS_AUTHORIZED,
  STATUS_CAPTURED,
  STATUS_FAILED,
  STATUS_REFUNDED,
  STATUS_CANCELLED,
];

export const PAYMENT_METHODS = [
  PAYMENT_METHOD_CB,
  PAYMENT_METHOD_TFE,
];

export const PROVIDERS = [
  PROVIDER_STRIPE,
  PROVIDER_PANDAPAY,
  PROVIDER_PAYPAL,
  PROVIDER_NUVEI,
];